
// // import React, { useEffect, useState } from 'react';
// // import {
// //   Box,
// //   Typography,
// //   TextField,
// //   Button,
// //   FormControlLabel,
// //   Checkbox,
// //   CircularProgress,
// //   ListItemText,
// //   Menu,
// //   MenuItem,
// //   useMediaQuery,
// //   useTheme,
// // } from '@mui/material';
// // import axios from 'axios';
// // import { useLocation, useNavigate } from 'react-router-dom';
// // import apiUrl from '../../Config';

// // const AddEditCombos = () => {
// //   const navigate = useNavigate();
// //   const { state } = useLocation();
// //   const editingCombo = state?.combo;

// //   const [title, setTitle] = useState(editingCombo?.title || '');
// //   const [description, setDescription] = useState(editingCombo?.description || '');
// //   const [price, setPrice] = useState(editingCombo?.price || '');
// //   const [discountOffer, setDiscountOffer] = useState(editingCombo?.discountOffer || '');
// //   const [isActive, setIsActive] = useState(editingCombo?.isActive ?? true);
// //   const [selectedBooks, setSelectedBooks] = useState(
// //   editingCombo?.comboOfferBooks
// //     ? editingCombo.comboOfferBooks.map((item) => item.bookId)
// //     : []
// // );
// //   const [comboImg, setComboImg] = useState(null);
// //   const [allBooks, setAllBooks] = useState([]);
// //   const [loading, setLoading] = useState(false);

// //   // For dropdown menu anchor and search term
// //   const [anchorEl, setAnchorEl] = useState(null);
// //   const [searchTerm, setSearchTerm] = useState('');

// //   const theme = useTheme();
// //   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

// //   // Fetch all books
// //   const getAllBooks = async () => {
// //     try {
// //       const res = await axios.get(`${apiUrl}/books/getallbooksadmin?page=1&limit=100`);
// //       setAllBooks(res.data.books || []);
// //     } catch (err) {
// //       console.error('Error fetching books', err);
// //     }
// //   };

// //   useEffect(() => {
// //     getAllBooks();
// //   }, []);

// //   // Open dropdown
// //   const handleToggleDropdown = (event) => {
// //     setAnchorEl(event.currentTarget);
// //   };

// //   // Close dropdown and reset search
// //   const handleCloseDropdown = () => {
// //     setAnchorEl(null);
// //     setSearchTerm('');
// //   };

// //   // Toggle book selection
// //   const handleCheckboxToggle = (bookId) => {
// //     if (selectedBooks.includes(bookId)) {
// //       setSelectedBooks(selectedBooks.filter((id) => id !== bookId));
// //     } else {
// //       setSelectedBooks([...selectedBooks, bookId]);
// //     }
// //   };

// //   // Filter books manually by search term
// //   const filteredBooks = allBooks.filter((book) =>
// //     book.title.toLowerCase().includes(searchTerm.toLowerCase())
// //   );

// //   const handleImageChange = (e) => {
// //     setComboImg(e.target.files[0]);
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();

// //     const formData = new FormData();
// //     formData.append('title', title);
// //     formData.append('description', description);
// //     formData.append('price', price);
// //     formData.append('discountOffer', discountOffer);
// //     formData.append('isActive', isActive);
// //     selectedBooks.forEach((id) => formData.append('offerBooks[]', id));
// //     if (comboImg) {
// //       formData.append('comboOfferImg', comboImg);
// //     }

// //     try {
// //       setLoading(true);
// //       if (editingCombo) {
// //         await axios.put(`${apiUrl}/combooffers/updatecombooffer/${editingCombo.id}`, formData, {
// //           headers: { 'Content-Type': 'multipart/form-data' },
// //         });
// //       } else {
// //         await axios.post(`${apiUrl}/combooffers/createcombooffer`, formData, {
// //           headers: { 'Content-Type': 'multipart/form-data' },
// //         });
// //       }
// //       navigate('/display-combos');
// //     } catch (err) {
// //       console.error('Error saving combo', err);
// //       alert('Error saving combo. Check console.');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   return (
// //     <Box
// //       p={isMobile ? 2 : 4}
// //       maxWidth={isMobile ? '100%' : 600}
// //       mx="auto"
// //       component="form"
// //       onSubmit={handleSubmit}
// //       encType="multipart/form-data"
// //       sx={{
// //         boxShadow: 3,
// //         borderRadius: 2,
// //         bgcolor: 'background.paper',
// //       }}
// //     >
// //       <Typography variant={isMobile ? 'h6' : 'h5'} mb={3} textAlign="center">
// //         {editingCombo ? 'Edit Combo Offer' : 'Create New Combo Offer'}
// //       </Typography>

// //       <TextField
// //         label="Title"
// //         value={title}
// //         onChange={(e) => setTitle(e.target.value)}
// //         fullWidth
// //         margin="normal"
// //         required
// //         size={isMobile ? 'small' : 'medium'}
// //       />
// //       <TextField
// //         label="Description"
// //         value={description}
// //         onChange={(e) => setDescription(e.target.value)}
// //         fullWidth
// //         margin="normal"
// //         required
// //         multiline
// //         rows={3}
// //         size={isMobile ? 'small' : 'medium'}
// //       />
// //       <TextField
// //         label="Price (₹)"
// //         type="number"
// //         value={price}
// //         onChange={(e) => setPrice(e.target.value)}
// //         fullWidth
// //         margin="normal"
// //         required
// //         size={isMobile ? 'small' : 'medium'}
// //         inputProps={{ min: 0, step: '0.01' }}
// //       />
// //       <TextField
// //         label="Discount (%)"
// //         type="number"
// //         value={discountOffer}
// //         onChange={(e) => setDiscountOffer(e.target.value)}
// //         fullWidth
// //         margin="normal"
// //         required
// //         size={isMobile ? 'small' : 'medium'}
// //         inputProps={{ min: 0, max: 100 }}
// //       />

// //       <FormControlLabel
// //         control={
// //           <Checkbox checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
// //         }
// //         label="Active"
// //       />

// //       <Box mt={2}>
// //         <Typography variant="subtitle1" mb={1}>
// //           Select Books
// //         </Typography>

// //         <Button
// //           variant="outlined"
// //           onClick={handleToggleDropdown}
// //           sx={{ width: '100%', textAlign: 'left' }}
// //         >
// //           {selectedBooks.length > 0
// //             ? allBooks
// //                 .filter((book) => selectedBooks.includes(book.id))
// //                 .map((b) => b.title)
// //                 .join(', ')
// //             : 'Select Books'}
// //         </Button>

// //         <Menu
// //           anchorEl={anchorEl}
// //           open={Boolean(anchorEl)}
// //           onClose={handleCloseDropdown}
// //           PaperProps={{
// //             style: { maxHeight: 300, width: '100%', maxWidth: 600, padding: 8 },
// //           }}
// //           keepMounted
// //         >
// //           <TextField
// //             placeholder="Search books..."
// //             size={isMobile ? 'small' : 'medium'}
// //             variant="outlined"
// //             value={searchTerm}
// //             onChange={(e) => setSearchTerm(e.target.value)}
// //             fullWidth
// //             autoFocus
// //             sx={{ mb: 1 }}
// //           />

// //           {filteredBooks.length === 0 && (
// //             <Typography
// //               variant="body2"
// //               align="center"
// //               color="text.secondary"
// //               sx={{ p: 1 }}
// //             >
// //               No books found
// //             </Typography>
// //           )}

// //           {filteredBooks.map((book) => (
// //             <MenuItem
// //               key={book.id}
// //               onClick={() => handleCheckboxToggle(book.id)}
// //               dense
// //               disableRipple
// //             >
// //               <Checkbox checked={selectedBooks.includes(book.id)} />
// //               <ListItemText primary={book.title} />
// //             </MenuItem>
// //           ))}
// //         </Menu>
// //       </Box>

// //       <Box mt={2}>
// //         <Button variant="contained" component="label" fullWidth={isMobile}>
// //           {comboImg
// //             ? comboImg.name
// //             : editingCombo?.comboOfferImg
// //             ? 'Change Image'
// //             : 'Upload Image'}
// //           <input type="file" hidden accept="image/*" onChange={handleImageChange} />
// //         </Button>
// //       </Box>

// //       <Box
// //         mt={4}
// //         display="flex"
// //         flexDirection={isMobile ? 'column' : 'row'}
// //         gap={2}
// //         justifyContent="center"
// //       >
// //         <Button
// //           type="submit"
// //           variant="contained"
// //           color="primary"
// //           disabled={loading}
// //           fullWidth={isMobile}
// //           size={isMobile ? 'medium' : 'large'}
// //         >
// //           {loading ? (
// //             <CircularProgress size={24} color="inherit" />
// //           ) : editingCombo ? (
// //             'Update Combo'
// //           ) : (
// //             'Create Combo'
// //           )}
// //         </Button>

// //         <Button
// //           onClick={() => navigate(-1)}
// //           disabled={loading}
// //           variant="outlined"
// //           fullWidth={isMobile}
// //           size={isMobile ? 'medium' : 'large'}
// //         >
// //           Cancel
// //         </Button>
// //       </Box>
// //     </Box>
// //   );
// // };

// // export default AddEditCombos;

// import React, { useEffect, useState } from 'react';
// import {
//   Box,
//   Typography,
//   TextField,
//   Button,
//   FormControlLabel,
//   Checkbox,
//   CircularProgress,
//   ListItemText,
//   Menu,
//   MenuItem,
//   useMediaQuery,
//   useTheme,
//   Chip,
//   Avatar,
//   IconButton,
// } from '@mui/material';
// import axios from 'axios';
// import { useLocation, useNavigate } from 'react-router-dom';
// import apiUrl from '../../Config';

// const AddEditCombos = () => {
//   const navigate = useNavigate();
//   const { state } = useLocation();
//   const editingCombo = state?.combo;

//   const [title, setTitle] = useState(editingCombo?.title || '');
//   const [description, setDescription] = useState(editingCombo?.description || '');
//   const [price, setPrice] = useState(editingCombo?.price || '');
//   const [discountOffer, setDiscountOffer] = useState(editingCombo?.discountOffer || '');
//   const [isActive, setIsActive] = useState(editingCombo?.isActive ?? true);
//   const [selectedBooks, setSelectedBooks] = useState(
//     editingCombo?.comboOfferBooks
//       ? editingCombo.comboOfferBooks.map((item) => item.bookId)
//       : []
//   );
//   const [comboImg, setComboImg] = useState(null);
//   const [allBooks, setAllBooks] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // For dropdown menu anchor and search term
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   // Fetch all books
//   const getAllBooks = async () => {
//     try {
//       const res = await axios.get(`${apiUrl}/books/getallbooksadmin?page=1&limit=100`);
//       setAllBooks(res.data.books || []);
//     } catch (err) {
//       console.error('Error fetching books', err);
//     }
//   };

//   useEffect(() => {
//     getAllBooks();
//   }, []);

//   // Open dropdown
//   const handleToggleDropdown = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   // Close dropdown and reset search
//   const handleCloseDropdown = () => {
//     setAnchorEl(null);
//     setSearchTerm('');
//   };

//   // Toggle book selection
//   const handleCheckboxToggle = (bookId) => {
//     if (selectedBooks.includes(bookId)) {
//       setSelectedBooks(selectedBooks.filter((id) => id !== bookId));
//     } else {
//       setSelectedBooks([...selectedBooks, bookId]);
//     }
//   };

//   // Filter books manually by search term
//   const filteredBooks = allBooks.filter((book) =>
//     book.title.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const handleImageChange = (e) => {
//     setComboImg(e.target.files[0]);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();
//     formData.append('title', title);
//     formData.append('description', description);
//     formData.append('price', price);
//     formData.append('discountOffer', discountOffer);
//     formData.append('isActive', isActive);
//     selectedBooks.forEach((id) => formData.append('offerBooks[]', id));
//     if (comboImg) {
//       formData.append('comboOfferImg', comboImg);
//     }

//     try {
//       setLoading(true);
//       if (editingCombo) {
//         await axios.put(`${apiUrl}/combooffers/updatecombooffer/${editingCombo.id}`, formData, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//         });
//       } else {
//         await axios.post(`${apiUrl}/combooffers/createcombooffer`, formData, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//         });
//       }
//       navigate('/display-combos');
//     } catch (err) {
//       console.error('Error saving combo', err);
//       alert('Error saving combo. Check console.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleRemoveBook = (bookId) => {
//     setSelectedBooks(selectedBooks.filter((id) => id !== bookId));
//   };

//   return (
//     <Box
//       p={isMobile ? 2 : 4}
//       maxWidth={isMobile ? '100%' : 600}
//       mx="auto"
//       component="form"
//       onSubmit={handleSubmit}
//       encType="multipart/form-data"
//       sx={{
//         boxShadow: 3,
//         borderRadius: 2,
//         bgcolor: 'background.paper',
//       }}
//     >
//       <Typography variant={isMobile ? 'h6' : 'h5'} mb={3} textAlign="center">
//         {editingCombo ? 'Edit Combo Offer' : 'Create New Combo Offer'}
//       </Typography>

//       <TextField
//         label="Title"
//         value={title}
//         onChange={(e) => setTitle(e.target.value)}
//         fullWidth
//         margin="normal"
//         required
//         size={isMobile ? 'small' : 'medium'}
//       />
//       <TextField
//         label="Description"
//         value={description}
//         onChange={(e) => setDescription(e.target.value)}
//         fullWidth
//         margin="normal"
//         required
//         multiline
//         rows={3}
//         size={isMobile ? 'small' : 'medium'}
//       />
//       <TextField
//         label="Price (₹)"
//         type="number"
//         value={price}
//         onChange={(e) => setPrice(e.target.value)}
//         fullWidth
//         margin="normal"
//         required
//         size={isMobile ? 'small' : 'medium'}
//         inputProps={{ min: 0, step: '0.01' }}
//       />
//       <TextField
//         label="Discount (%)"
//         type="number"
//         value={discountOffer}
//         onChange={(e) => setDiscountOffer(e.target.value)}
//         fullWidth
//         margin="normal"
//         required
//         size={isMobile ? 'small' : 'medium'}
//         inputProps={{ min: 0, max: 100 }}
//       />

//       <FormControlLabel
//         control={
//           <Checkbox checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
//         }
//         label="Active"
//       />

//       <Box mt={2}>
//         <Typography variant="subtitle1" mb={1}>
//           Select Books
//         </Typography>

//         <Box display="flex" flexWrap="wrap" gap={1}>
//           {selectedBooks.map((bookId) => (
//             <Chip
//               key={bookId}
//               label={allBooks.find((book) => book.id === bookId)?.title}
//               onDelete={() => handleRemoveBook(bookId)}
//               color="primary"
//               variant="outlined"
//             />
//           ))}
//         </Box>

//         <Button
//           variant="outlined"
//           onClick={handleToggleDropdown}
//           sx={{ width: '100%', textAlign: 'left', mt: 1 }}
//         >
//           Add Books
//         </Button>

//         <Menu
//           anchorEl={anchorEl}
//           open={Boolean(anchorEl)}
//           onClose={handleCloseDropdown}
//           PaperProps={{
//             style: { maxHeight: 300, width: '100%', maxWidth: 600, padding: 8 },
//           }}
//           keepMounted
//         >
//           <TextField
//             placeholder="Search books..."
//             size={isMobile ? 'small' : 'medium'}
//             variant="outlined"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             fullWidth
//             autoFocus
//             sx={{ mb: 1 }}
//           />

//           {filteredBooks.length === 0 && (
//             <Typography
//               variant="body2"
//               align="center"
//               color="text.secondary"
//               sx={{ p: 1 }}
//             >
//               No books found
//             </Typography>
//           )}

//           {filteredBooks.map((book) => (
//             <MenuItem
//               key={book.id}
//               onClick={() => handleCheckboxToggle(book.id)}
//               dense
//               disableRipple
//             >
//               <Checkbox checked={selectedBooks.includes(book.id)} />
//               <ListItemText primary={book.title} />
//             </MenuItem>
//           ))}
//         </Menu>
//       </Box>

//       <Box mt={2}>
//         <Button variant="contained" component="label" fullWidth={isMobile}>
//           {comboImg
//             ? comboImg.name
//             : editingCombo?.comboOfferImg
//             ? 'Change Image'
//             : 'Upload Image'}
//           <input type="file" hidden accept="image/*" onChange={handleImageChange} />
//         </Button>
//       </Box>

//       <Box
//         mt={4}
//         display="flex"
//         flexDirection={isMobile ? 'column' : 'row'}
//         gap={2}
//         justifyContent="center"
//       >
//         <Button
//           type="submit"
//           variant="contained"
//           color="primary"
//           disabled={loading}
//           fullWidth={isMobile}
//           size={isMobile ? 'medium' : 'large'}
//         >
//           {loading ? (
//             <CircularProgress size={24} color="inherit" />
//           ) : editingCombo ? (
//             'Update Combo'
//           ) : (
//             'Create Combo'
//           )}
//         </Button>

//         <Button
//           onClick={() => navigate(-1)}
//           disabled={loading}
//           variant="outlined"
//           fullWidth={isMobile}
//           size={isMobile ? 'medium' : 'large'}
//         >
//           Cancel
//         </Button>
//       </Box>
//     </Box>
//   );
// };

// export default AddEditCombos;


import React, { useEffect, useState } from 'react';
import {
    Box,
    Typography,
    TextField,
    Button,
    FormControlLabel,
    Checkbox,
    CircularProgress,
    ListItemText,
    Menu,
    MenuItem,
    useMediaQuery,
    useTheme,
    Chip,
    IconButton,
    Grid,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close'; // Import CloseIcon
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import apiUrl from '../../Config';
import { toast } from 'react-toastify';

const AddEditCombos = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const editingCombo = state?.combo;


    const [title, setTitle] = useState(editingCombo?.title || '');
    const [description, setDescription] = useState(editingCombo?.description || '');
    const [price, setPrice] = useState(editingCombo?.price || '');
    const [discountOffer, setDiscountOffer] = useState(editingCombo?.discountOffer || '');
    const [isActive, setIsActive] = useState(editingCombo?.isActive ?? true);
    const [selectedBooks, setSelectedBooks] = useState(
        editingCombo?.comboOfferBooks
            ? editingCombo.comboOfferBooks.map((item) => item.bookId)
            : []
    );
    const [comboImg, setComboImg] = useState(null);
    const [comboImgPreview, setComboImgPreview] = useState(editingCombo?.imageUrl || null);
    const [allBooks, setAllBooks] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formErrors, setFormErrors] = useState({});

    const [anchorEl, setAnchorEl] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [error,setError]=useState('')

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // Fetch all books
    const getAllBooks = async () => {
        try {
            const res = await axios.get(`${apiUrl}/books/getallbooksadmin?page=1&limit=100`);
            setAllBooks(res.data.books || []);
        } catch (err) {
          setError('Error fetching books', err);
        }
    };

    useEffect(() => {
        getAllBooks();
    }, []);

    // Open dropdown
    const handleToggleDropdown = (event) => {
        setAnchorEl(event.currentTarget);
    };

    // Close dropdown and reset search
    const handleCloseDropdown = () => {
        setAnchorEl(null);
        setSearchTerm('');
    };

    // Toggle book selection
    const handleCheckboxToggle = (bookId) => {
        if (selectedBooks.includes(bookId)) {
            setSelectedBooks(selectedBooks.filter((id) => id !== bookId));
        } else {
            setSelectedBooks([...selectedBooks, bookId]);
        }
    };

    // Filter books manually by search term
    const filteredBooks = allBooks.filter((book) =>
        book.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setComboImg(file);
            setComboImgPreview(URL.createObjectURL(file)); // Create a URL for preview
        } else {
            setComboImg(null);
            setComboImgPreview(editingCombo?.comboOfferImg || null); // Revert to existing or null
        }
    };

    const handleRemoveBook = (bookId) => {
        setSelectedBooks(selectedBooks.filter((id) => id !== bookId));
    };

    const validateForm = () => {
        let errors = {};
        let isValid = true;

        if (selectedBooks.length < 2) {
            errors.selectedBooks = 'Please select at least 2 books for the combo.';
            isValid = false;
        }

        if (!title.trim()) {
            errors.title = 'Title is required.';
            isValid = false;
        }
        if (!description.trim()) {
            errors.description = 'Description is required.';
            isValid = false;
        }
        if (!price || price <= 0) {
            errors.price = 'Price must be a positive number.';
            isValid = false;
        }
        if (discountOffer < 0 || discountOffer > 100) {
            errors.discountOffer = 'Discount must be between 0 and 100.';
            isValid = false;
        }

        setFormErrors(errors);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            toast.error('Please fix all validation errors');
            return;
        }

        const formData = new FormData();
        formData.append('title', title);
        formData.append('description', description);
        formData.append('price', price);
        formData.append('discountOffer', discountOffer);
        formData.append('isActive', isActive);
        selectedBooks.forEach((id) => formData.append('offerBooks[]', id));
        if (comboImg) {
            formData.append('comboOfferImg', comboImg);
        }

        try {
            setLoading(true);
            if (editingCombo) {
                await axios.put(`${apiUrl}/combooffers/updatecombooffer/${editingCombo.id}`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
            } else {
                await axios.post(`${apiUrl}/combooffers/createcombooffer`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
            }
            toast.success(editingCombo ? 'Combo updated successfully!' : 'Combo created successfully!');
            navigate('/display-combos');
        } catch (err) {
            toast.error(err.response?.data?.message || 'Error saving combo. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            p={isMobile ? 2 : 4}
            maxWidth={isMobile ? '100%' : '100%'}
            mx="auto"
            component="form"
            onSubmit={handleSubmit}
            encType="multipart/form-data"
            sx={{
                // boxShadow: 3,
                // borderRadius: 2,
                // bgcolor: 'background.paper',
            }}
        >
            <Typography variant={isMobile ? 'h6' : 'h5'} mt={0.5} mb={2} textAlign="left">
                {editingCombo ? 'Edit Combo Offer' : 'Create New Combo Offer'}
            </Typography>
            <Box sx={{ display: 'flex', gap: isMobile ? 0 : 2, flexDirection: isMobile ? 'column' : 'row' }}>
                <TextField
                    label="Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    fullWidth
                    margin="normal"
                    size={isMobile ? 'small' : 'small'}
                    error={!!formErrors.title}
                    helperText={formErrors.title}
                />
                <TextField
                    label="Price (₹)"
                    type="number"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    fullWidth
                    margin="normal"
                    size={isMobile ? 'small' : 'small'}
                    inputProps={{ min: 0, step: '0.01' }}
                    error={!!formErrors.price}
                    helperText={formErrors.price}
                />
            </Box>

            <TextField
                label="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                fullWidth
                margin="normal"
                multiline
                rows={3}
                size={isMobile ? 'small' : 'small'}
                error={!!formErrors.description}
                helperText={formErrors.description}
            />

            <Box sx={{ display: 'flex', gap: isMobile ? 0 : 2, flexDirection: isMobile ? 'column' : 'row' }}>
                <TextField
                    label="Discount (%)"
                    type="number"
                    value={discountOffer}
                    onChange={(e) => setDiscountOffer(e.target.value)}
                    sx={{ width: isMobile ? '100%' : '49.3%' }}

                    margin="normal"
                    size={isMobile ? 'small' : 'small'}
                    inputProps={{ min: 0, max: 100 }}
                    error={!!formErrors.discountOffer}
                    helperText={formErrors.discountOffer}
                />

                <FormControlLabel
                    control={
                        <Checkbox checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
                    }
                    label="Active"
                />
            </Box>

            <Grid container sx={{ display: 'flex', gap: isMobile ? 0 : 2, flexDirection: isMobile ? 'column' : 'row' }}>

                <Grid size={{ xs: 12, sm: 12, md: 5.5 }} mt={2}>
                    <Typography variant="subtitle1" mb={1}>
                        Select Image
                    </Typography>
                    <Button variant="contained" component="label" fullWidth={isMobile}>
                        {comboImg
                            ? comboImg.name
                            : editingCombo?.comboOfferImg
                                ? 'Change Image'
                                : 'Upload Image'}
                        <input type="file" hidden accept="image/*" onChange={handleImageChange} />
                    </Button>
                    {comboImgPreview && (
                        <Box mt={2} textAlign="center">
                            <Typography variant="subtitle2" mb={1}>
                                Image Preview:
                            </Typography>
                            <img
                                src={comboImgPreview}
                                alt="Combo Preview"
                                style={{ maxWidth: '100%', maxHeight: 200, objectFit: 'contain', border: '1px solid #ddd', borderRadius: '4px' }}
                            />
                        </Box>
                    )}
                </Grid>

                <Grid size={{ xs: 12, sm: 12, md: 5.5 }} mt={2}>
                    <Typography variant="subtitle1" mb={1}>
                        Select Books
                    </Typography>

                    <Box display="flex" flexWrap="wrap" gap={1} mb={1}>
                        {selectedBooks.map((bookId) => {
                            const book = allBooks.find((b) => b.id === bookId);
                            return book ? (
                                <Chip
                                    key={book.id}
                                    label={book.title}
                                    onDelete={() => handleRemoveBook(book.id)}
                                    color="primary"
                                    variant="outlined"
                                />
                            ) : null;
                        })}
                    </Box>
                    {formErrors.selectedBooks && (
                        <Typography color="error" variant="caption">
                            {formErrors.selectedBooks}
                        </Typography>
                    )}

                    <Button
                        variant="outlined"
                        onClick={handleToggleDropdown}
                        sx={{ width: '100%', textAlign: 'left', mt: 1 }}
                    >
                        Add Books
                    </Button>

                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleCloseDropdown}
                        PaperProps={{
                            style: { maxHeight: 300, width: '100%', maxWidth: 600, padding: 8 },
                        }}
                        keepMounted
                    >
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                            <TextField
                                placeholder="Search books..."
                                size={isMobile ? 'small' : 'medium'}
                                variant="outlined"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                fullWidth
                                autoFocus
                            />
                            <IconButton onClick={handleCloseDropdown}>
                                <CloseIcon />
                            </IconButton>
                        </Box>

                        {filteredBooks.length === 0 && (
                            <Typography
                                variant="body2"
                                align="center"
                                color="text.secondary"
                                sx={{ p: 1 }}
                            >
                                No books found
                            </Typography>
                        )}

                        {filteredBooks.map((book) => (
                            <MenuItem
                                key={book.id}
                                onClick={() => handleCheckboxToggle(book.id)}
                                dense
                                disableRipple
                            >
                                <Checkbox checked={selectedBooks.includes(book.id)} />
                                <ListItemText primary={book.title} />
                            </MenuItem>
                        ))}
                    </Menu>
                </Grid>


            </Grid>

            <Box
                mt={4}
                display="flex"
                // flexDirection={isMobile ? 'column' : 'row'}
                gap={2}
                justifyContent="end"
            >
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={loading}
                    fullWidth={isMobile}
                    size={isMobile ? 'small' : 'medium'}
                >
                    {loading ? (
                        <CircularProgress size={24} color="inherit" />
                    ) : editingCombo ? (
                        'Update Combo'
                    ) : (
                        'Create Combo'
                    )}
                </Button>

                <Button
                    onClick={() => navigate(-1)}
                    disabled={loading}
                    variant="outlined"
                    fullWidth={isMobile}
                    size={isMobile ? 'small' : 'medium'}
                >
                    Cancel
                </Button>
            </Box>
        </Box>
    );
};

export default AddEditCombos;

